import React from 'react'
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import _ from "lodash"
import { useSelector } from 'react-redux'

function AiChatHistory({ loop, highlightColor = '#d3d3d3' }) {
  const theme = useSelector(state => state.theme.theme)

  return (
    <SkeletonTheme baseColor="#fff" highlightColor={highlightColor}>                 
      {_.times(loop !== undefined ? loop : 7, (key) => {
        return (
            <li key={key}>
                {
                    (
                        <SkeletonTheme baseColor={theme == "dark" ? "#202020" : "#f0f0f0"} highlightColor={theme == "dark" ? "#444" : "#f0f0f0"}>
                            <div className='histry-title'>
                                <span className='histry-title-name'><s><Skeleton height={"30px"} width= "320px" /></s></span>
                            </div>
                        </SkeletonTheme>
                    )
                }
            </li>
        );
      })}
    </SkeletonTheme>
  );
}

export default AiChatHistory